import moment from 'moment'
import 'moment-duration-format'

export const minimumConnectionTimeInMin = {
    CRITICAL: 15,
    DEFAULT: {
        SCHENGEN_TO_SCHENGEN: 30,
        SCHENGEN_TO_NON_SCHENGEN: 45,
        NON_SCHENGEN_TO_NON_SCHENGEN: 40
    },
    RIX: {
        SCHENGEN_TO_SCHENGEN: 30,
        SCHENGEN_TO_NON_SCHENGEN: 45,
        NON_SCHENGEN_TO_NON_SCHENGEN: 40
    }
}

export function connectionTime (inboundFlight, outboundFlight) {
    if (inboundFlight.arrivalAt && outboundFlight.departureAt) {
        const diff = moment(outboundFlight.departureAt).diff(moment(inboundFlight.arrivalAt))
        return moment.duration(diff).format('HH:mm', {trim: false})
    }
    return '--:--'
}

export function calculateConnectionTimeInMinutes (inboundFlight, outboundFlight) {
    return moment(outboundFlight.departureAt).diff(moment(inboundFlight.arrivalAt), 'minutes')
}

export function calculateConnectionStatus (inboundFlight, outboundFlight) {
    if (!inboundFlight || !outboundFlight) {
        return
    }
    const arrivalAirport = inboundFlight.actualArrivalAirport || inboundFlight.scheduledArrivalAirport
    const departureAirport = outboundFlight.actualDepartureAirport || outboundFlight.scheduledDepartureAirport
    const flightAreaType = inboundFlight.flightAreaType ? inboundFlight.flightAreaType : outboundFlight.flightAreaType

    const mctArray = minimumConnectionTimeInMin[arrivalAirport] ? minimumConnectionTimeInMin[arrivalAirport] : minimumConnectionTimeInMin.DEFAULT
    if (arrivalAirport !== departureAirport || !mctArray[flightAreaType]) {
        return
    }
    const mct = mctArray[flightAreaType]
    const connectionTimeInMinutes = calculateConnectionTimeInMinutes(inboundFlight, outboundFlight)

    if (connectionTimeInMinutes >= mct) {
        return 'OK'
    } else if (connectionTimeInMinutes >= minimumConnectionTimeInMin.CRITICAL) {
        return 'CRITICAL'
    }

    return 'NEGATIVE'
}